import {
    gridGutterHalf,
    fontSize24
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import theme from '../../../../../../js/shared/new-theme';

export const defaultStyle = `
    display: flex;
    flex-direction: column;
    flex: 1;
    flex-basis: 100%;    
    
    p {
        margin: 0;
        text-align: center;
    }

    .expected {
        &--tooltip {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;

            > div {
                margin-left: ${gridGutterHalf}px;
                align-self: center;
            }
        }

        &--text {
            flex-basis: 100%;
        }

        &--price {
            font-weight: bold;
            color: ${theme.palette.gray[800].value};

            strong {
                font-size: ${fontSize24};    
            }
        }
    }
`;
